export default "__VITE_ASSET__BHuZ8Byz__"